// extracted by mini-css-extract-plugin
export default {"give":"GIve_give__XEWx7","giveContainer":"GIve_giveContainer__q7Caf","giveText":"GIve_giveText__lQhQK"};